const pageTitle = {
  'Google Merchant Center': 'Google Merchant Center - ショッピング広告設定',
};

export default pageTitle;
